import { isSameDay as isSameDay_ } from "date-fns";

import type { Time } from "../time";

export function isSameDay(first: Time, second: Time, ...rest: ReadonlyArray<Time>): boolean;
export function isSameDay(first: Time, ...rest: ReadonlyArray<Time>): boolean {
	return rest.every((time) => isSameDay_(first, time));
}
